module.exports = __webpack_public_path__ + "img/vision_03.c71b0797.jpg";